<div class="ufp-modal-overlay">
  <div class="ufp-modal-container">
    <div class="ufp-login-card">
      <div class="ufp-card-header">
        <h2 class="ufp-card-title">Welcome</h2>
        <p class="ufp-card-description">Sign in to your account.</p>
        <button class="ufp-close-button" (click)="closeModalHandler()">×</button>
      </div>
      <div class="ufp-card-content">
        <div class="ufp-tabs">
          <div class="ufp-tab-list">
            <button [class.active]="activeTab === 'signin'" (click)="setActiveTab('signin')" class="ufp-tab-trigger">Sign In</button>
            <!-- Temporarily hiding Sign Up tab -->
            <!-- <button *ngIf="enableSignup" [class.active]="activeTab === 'signup'" (click)="setActiveTab('signup')" class="ufp-tab-trigger">Sign Up</button> -->
          </div>

          <!-- Sign In Content -->
          <div class="ufp-tab-content" *ngIf="activeTab === 'signin'">
            <div class="ufp-login-form">
              <!-- Login Method Tabs -->
              <div class="ufp-method-tabs">
                <button [class.active]="loginMethod === 'email'" (click)="setLoginMethod('email')" class="ufp-method-tab">Email</button>
                <button [class.active]="loginMethod === 'phone'" (click)="setLoginMethod('phone')" class="ufp-method-tab">Phone</button>
              </div>

              <!-- Alert Message - Moved to top -->
              <div class="ufp-alert-message" [class.success]="alertMessage.includes('OTP has been sent')" *ngIf="alertMessage">{{ alertMessage }}</div>

              <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
                <!-- Email Input -->
                <div class="ufp-form-group compact" *ngIf="loginMethod === 'email'">
                  <div class="ufp-input-with-icon">
                    <i class="ufp-input-icon ufp-user-icon"></i>
                    <input
                      id="email"
                      type="email"
                      #emailInput
                      [formControlName]="'email'"
                      placeholder="Enter your email"
                      class="ufp-form-input with-icon"
                      [class.invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
                    />
                  </div>
                  <div class="ufp-error-text" *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
                    Please enter a valid email address
                  </div>
                </div>

                <!-- Phone Input -->
                <div class="ufp-form-group compact" *ngIf="loginMethod === 'phone'">
                  <div class="ufp-phone-input-group">
                    <input id="countryCode" type="text" formControlName="countryCode" placeholder="+91" class="ufp-country-code-input">
                    <input id="phone" type="tel" formControlName="phoneNumber" placeholder="Enter phone number" class="ufp-phone-input">
                  </div>
                </div>

                <!-- Password Input - Hidden in OTP only mode -->
                <div class="ufp-form-group" *ngIf="!showOtpVerification && !isOtpOnlyMode">
                  <div class="ufp-input-with-icon">
                    <i class="ufp-input-icon ufp-lock-icon"></i>
                    <input id="password" [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="Enter your password" class="ufp-form-input with-icon">
                    <button type="button" (click)="togglePasswordVisibility()" class="ufp-password-toggle">
                      <i class="ufp-eye-icon" [class.visible]="showPassword"></i>
                    </button>
                  </div>
                </div>

                <!-- Links - Conditional based on auth mode -->
                <div class="ufp-form-links" *ngIf="!showOtpVerification && !isOtpOnlyMode && !isBasicAuthOnlyMode">
                  <button type="button" class="ufp-link-button" (click)="toggleOtpLogin()">Sign-in using OTP</button>
                </div>

                <!-- Sign In Button - Different text for OTP only mode -->
                <button type="submit" class="ufp-submit-button" *ngIf="!showOtpVerification && !isOtpOnlyMode">Sign In</button>
                <button type="button" class="ufp-submit-button" *ngIf="!showOtpVerification && isOtpOnlyMode" (click)="requestOtpDirectly()">Send OTP</button>
              </form>

              <!-- OTP Verification -->
              <div class="ufp-otp-section" *ngIf="showOtpVerification">
                <div class="ufp-otp-input-group">
                  <input *ngFor="let digit of [0,1,2,3]; let i = index"
                         type="text"
                         maxlength="1"
                         [value]="otpDigits[i]"
                         (keyup)="onOtpInput($event, i)"
                         (paste)="onOtpPaste($event)"
                         [attr.data-index]="i"
                         class="ufp-otp-input">
                </div>

                <!-- Moved form-links above the submit button -->
                <div class="ufp-form-links">
                  <button type="button" class="ufp-link-button" *ngIf="!isOtpOnlyMode" (click)="toggleOtpLogin()">Sign-in with password</button>
                  <button type="button" 
                          class="ufp-link-button" 
                          [disabled]="!canResendOtp"
                          (click)="requestNewOtp($event)">
                    {{ canResendOtp ? 'Resend OTP' : resendTimerText }}
                  </button>
                </div>

                <button type="button" class="ufp-submit-button" (click)="verifyOtp()">Sign In</button>
              </div>

              <!-- Social Login Section -->
              <div class="ufp-social-login-section" *ngIf="!showOtpVerification">
              <!-- <div class="ufp-divider">
                  <span>Or continue with</span>
                </div>

                <div class="ufp-social-buttons">
                  <button type="button" class="ufp-social-button" (click)="loginWithGoogle()">
                    <img [src]="googleLogo" alt="Google" class="ufp-social-icon">
                    Google
                  </button>
                  <button type="button" class="ufp-social-button" (click)="loginWithApple()">
                    <img [src]="appleLogo" alt="Apple" class="ufp-social-icon">
                    Apple
                  </button>
                  <button type="button" class="ufp-social-button" (click)="loginWithMicrosoft()">
                    <img [src]="microsoftLogo" alt="Microsoft" class="ufp-social-icon">
                    Microsoft
                  </button>
                </div> -->
              </div>
            </div>
          </div>

          <!-- Sign Up Content -->
          <div class="ufp-tab-content" *ngIf="activeTab === 'signup'">
            <form [formGroup]="signupForm" (ngSubmit)="onSignup()" class="ufp-signup-form">
              <div class="ufp-form-group">
                <label class="ufp-label" for="name">Name</label>
                <input id="name" type="text" formControlName="name" placeholder="Enter your name" class="ufp-form-input">
              </div>

              <div class="ufp-form-group">
                <label class="ufp-label" for="signup-email">Email</label>
                <input id="signup-email" type="email" formControlName="email" placeholder="Enter your email" class="ufp-form-input">
              </div>

              <div class="ufp-form-group">
                <label class="ufp-label" for="signup-password">Password</label>
                <input id="signup-password" type="password" formControlName="password" placeholder="Create a password" class="ufp-form-input">
              </div>

              <div class="ufp-form-group">
                <label class="ufp-label" for="repeat-password">Repeat Password</label>
                <input id="repeat-password" type="password" formControlName="repeatPassword" placeholder="Repeat your password" class="ufp-form-input">
              </div>

              <button type="submit" class="ufp-submit-button">Sign Up</button>

              <!-- Social Signup Section -->
              <div class="ufp-social-login-section">
                <div class="ufp-divider">
                  <span>Or sign up with</span>
                </div>

                <div class="ufp-social-buttons">
                  <button type="button" class="ufp-social-button" (click)="signupWithGoogle()">
                    <img [src]="googleLogo" alt="Google" class="ufp-social-icon">
                    Google
                  </button>
                  <button type="button" class="ufp-social-button" (click)="signupWithApple()">
                    <img [src]="appleLogo" alt="Apple" class="ufp-social-icon">
                    Apple
                  </button>
                  <button type="button" class="ufp-social-button" (click)="signupWithMicrosoft()">
                    <img [src]="microsoftLogo" alt="Microsoft" class="ufp-social-icon">
                    Microsoft
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
